<template>
  <input ref="date"
         type="text"
         class="form-control"
  >
</template>

<script>
  export default {
    props: [
      'value',
    ],

    mounted() {
      const self = this;
      const startIndex= moment.localeData(this.locale)._config.longDateFormat.L.length + 1;

      $(this.$refs.date).datetimepicker({
        format: this.$root.datetimeFormat,
        locale: this.$root.locale
      }).on('dp.change', function(e){
        if(!e.which) {
          self.$nextTick(()=>{
            e.target.setSelectionRange(startIndex, e.target.value.length);
          })
        }
        self.$emit('input', moment(e.date).toISOString());
      }).on('dp.show', function(e){
        self.$nextTick(()=>{
          e.target.setSelectionRange(startIndex, e.target.value.length);
        })
      });

      if(this.value) {
        this.setDate(this.value);
      }
    },
    methods: {
      setDate(date) {
        $(this.$refs.date).data("DateTimePicker").date(date ? moment(date) : null);
        // $(this.$refs.date).val(date ? moment(date).format(this.$root.datetimeFormat) : null).change()
      }
    },
    watch: {
      value(date) {
        this.setDate(date);
      }
    },
    beforeDestroy() {
      $(this.$refs.date).datetimepicker('destroy')
    }
  }
</script>
